module.exports = __webpack_public_path__ + "img/icons BFr_10.387535dd.svg";